import Button from 'components/Button'
import Control from 'components/Control/Control'
import FileReader from 'components/Uploader/FileReader'
import Uploadloader from 'components/Uploader/Uploader'
import React from 'react'
import BellIcon from '../../../components/icons/BellIcon'
import ConflictUpload from '../../../components/icons/ConflictUpload'
import DullIcon from '../../../components/icons/DullIcon'
import SmileIcon from '../../../components/icons/SmileIcon'
import {
  ConflictFlex,
  ConflictInnerContent,
  ConflictInnerFlex,
  FileError,
} from '../../ATS/style'
import {
  AlertFlex,
  ResultWrapper,
  StyledH2,
  StyledP,
  SubTextWrapper,
  TextWrapper,
} from './style'
import { FolderSpinner } from '../../Placement/style'
import { Space, Spin } from 'antd'
import { SmallButtons } from 'components/Uploader/Styles'
import {  Main } from 'components/ActionStyles/ActionStyles'

import {
  BoldText,
  InfoSection,
  LightText,
  SampleDocContainer,
} from 'modules/Students/Partials/StudentsBulkUpload/Style/style'
import { env } from '../../../utils/const'
import Download from 'components/icons/Download'
import styled from 'styled-components'

const Cirlcle = styled.div`
  padding: 4px;
  background: #4d566e;
  border-radius: 50% !important;
  margin-right: 9px;
`
const EventUpload = ({
  conflictStatus,
  handleUploadClick,
  handleFileUpload,
  setFileLoading,
  UploadedData,
  progress,
  setFinalUpload,
  setFile,
  file,
  setFailed,
  failed,
  bulkUploadResult,
  handleResolveConflict,
  fileLoading,
  bulkUploadError,
}) => {

  const onFileUploaded = file => {
    setFile(file)
    if (file?.url) {
      handleFileUpload(file?.url)
    }
    setFailed(false)
    setFinalUpload(0)
  }

  const downloadURI = () => {
    let uri =
      env.STUDENT_ATS_TEMPLATE ||
      'https://d18zc7o1u7b8o7.cloudfront.net/students/bulkupload/StudentAtsResultTemplate.xlsx'
    let name = 'SampleDoc'
    let link = document.createElement('a')
    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  return (
    <>
      {conflictStatus === '' ? (
        UploadedData.map(item => {
          return (
            <ConflictFlex onClick={() => handleUploadClick(item.status)}>
              <ConflictUpload />
              <ConflictInnerFlex>
                <ConflictInnerContent disable={true}>
                  {item.name}
                </ConflictInnerContent>
                <ConflictInnerContent>{item.content}</ConflictInnerContent>
              </ConflictInnerFlex>
            </ConflictFlex>
          )
        })
      ) : (
        <>
         <InfoSection>
            <Space>
              <SmallButtons
                height={'30px'}
                width="30px"
                border={true}
                icon={<Download />}
              />
              <SampleDocContainer>
                <BoldText>Candidate Sample Doc</BoldText>
                <LightText>To Upload bulk upload data, use template</LightText>
              </SampleDocContainer>
            </Space>
            <Main>
              <Button.Secondary
                 onClick={downloadURI}
                trigger={['click']}
                text="Download"
              ></Button.Secondary>
            </Main>
          </InfoSection>
          {!file && (
            <Uploadloader
              setFile={onFileUploaded}
              isDefault={true}
              fileName={`Event_Paid_Candidates`}
              format={' (.xlsx, .csv)'}
              setIsLoading={setFileLoading}
            />
          )}
          {fileLoading ? (
            <FolderSpinner style={{ marginTop: '3rem' }}>
              <Spin small tip="Loading" size="large" />
            </FolderSpinner>
          ) : (
            <>
              {file && (
                <FileReader
                  file={{
                    ...file,
                    name: file?.name?.replace(``, ''),
                  }}
                  setFile={onFileUploaded}
                  isLoader={true}
                  progress={progress}
                  failed={failed}
                />
              )}
              {!file && (
                <AlertFlex>
                  <Control column top="2px" bottom="2px">
                    <TextWrapper alignCenter>
                      <>
                        <BellIcon />
                        <StyledH2 alignCenter> Please note!</StyledH2>
                      </>
                    </TextWrapper>
                    <SubTextWrapper>
                      <Cirlcle />
                      <StyledP>Upload only the Paid Candidates.</StyledP>
                    </SubTextWrapper>
                    <SubTextWrapper>
                      <Cirlcle />
                      <StyledP>
                        Providing the student's email ID is mandatory.
                        Additionally, either the student's name or contact
                        number is mandatory{' '}
                      </StyledP>
                    </SubTextWrapper>
                  </Control>
                </AlertFlex>
              )}
              {file && (
                <Control column top="40px" bottom="2px">
                  {Number(bulkUploadResult?.data?.successRecords?.length) >
                  0 ? (
                    <ResultWrapper alignCenter>
                      <SmileIcon />
                      <StyledH2>
                        {Number(bulkUploadResult?.data?.successRecords?.length)}
                        &nbsp;student
                        {bulkUploadResult?.data?.successRecords?.length > 1
                          ? 's'
                          : ''}
                        {Number(
                          bulkUploadResult?.data?.successRecords?.length
                        ) > 1
                          ? ' are '
                          : ' is '}
                        successfully paid.
                      </StyledH2>
                    </ResultWrapper>
                  ) : (
                    <ResultWrapper alignCenter>
                      <DullIcon />
                      <StyledH2>
                        No candidates match for the above sheet
                      </StyledH2>
                    </ResultWrapper>
                  )}
                  {Number(bulkUploadResult?.data?.conflictCandidates?.length) >
                    0 && (
                    <>
                      <ResultWrapper alignCenter>
                        <DullIcon />
                        <StyledH2>
                          <>{'Status conflict with '}</>
                          {Number(bulkUploadResult?.data?.conflictCandidates?.length)}
                          {bulkUploadResult?.data?.conflictCandidates?.length >
                          0
                            ? ' candidates'
                            : ' candidate'}
                        </StyledH2>
                      </ResultWrapper>
                      <Control column top="10px">
                        <Button.Danger
                          wordBreak
                          text={'Resolve Conflicts'}
                          width="max-content"
                          onClick={() => handleResolveConflict()}
                        />
                      </Control>
                    </>
                  )}
                </Control>
              )}
              {file && Object?.keys(bulkUploadResult)?.length === 0 && (
                <FileError>{bulkUploadError}</FileError>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}

export default EventUpload
